import { API_URL } from './api';

export const avatarCache = {};
let avatarsFetched = new Set();
let avatarListeners = [];

export const onAvatarsLoaded = (callback) => {
  avatarListeners.push(callback);
  return () => {
    avatarListeners = avatarListeners.filter(cb => cb !== callback);
  };
};

const notifyAvatarListeners = () => {
  avatarListeners.forEach(cb => cb());
};

export const fetchAvatarsBulk = async (steamids) => {
  const newIds = steamids.filter(id => id && !avatarCache[id] && !avatarsFetched.has(String(id)));
  if (newIds.length === 0) return avatarCache;

  newIds.forEach(id => avatarsFetched.add(String(id)));

  try {
    const response = await fetch(`${API_URL}/api/avatars?steamids=${newIds.join(',')}`);
    const data = await response.json();
    if (data.avatars) {
      Object.assign(avatarCache, data.avatars);
      notifyAvatarListeners();
    }
  } catch (e) {
    console.error('Failed to fetch avatars:', e);
  }

  return avatarCache;
};
